<div class="chart-header">
    @if (block().title) {
        <p class="chart-title">{{ block().title }}</p>
    }
    <!-- Grouped so the switcher and Copy stay together at the right edge, with or without a
         title, and so a block offering one form still places Copy where the others do. -->
    <div class="chart-actions">
        <!-- FR-046: only the forms this data supports, and switching is local — no request. -->
        @if (showSwitcher()) {
            <div class="chart-forms" role="group" aria-label="Chart form">
                @for (option of availableKinds(); track option) {
                    <button
                        type="button"
                        class="chart-form"
                        [class.chart-form-active]="option === kind()"
                        [attr.aria-pressed]="option === kind()"
                        (click)="select(option)"
                    >
                        {{ label(option) }}
                    </button>
                }
            </div>
        }
        <!-- FR-047: copies the chart's data, which is what pastes into a message or a ticket. -->
        <button type="button" class="chart-copy" (click)="copy()" aria-label="Copy chart">Copy</button>
    </div>
</div>
<!-- Highcharts draws into this element. It reflows to the container, so the chart narrows with
     the side panel (FR-028) rather than widening the conversation. -->
<div class="chart-canvas" #chartContainer></div>
